import axios from 'axios'
import { API_BASE_URL } from '@/config/app'

const request = axios.create({
  baseURL: API_BASE_URL,  // 已在环境变量中包含 /api
  timeout: 10000
})

// 租户绑定域名（从后端响应头 X-Tenant-Domain 中获取）
let currentTenantDomain = ''

// 获取当前租户的绑定域名
export const getTenantDomain = () => currentTenantDomain

// 解析租户ID，根据页面类型使用不同优先级
// 后台管理页面(/admin)：admin用户 > localStorage > 不发送header
// 前台公开页面：URL参数 > localStorage > 不发送header(后端从域名解析)
const resolveTenantId = () => {
  const isAdminPage = window.location.pathname.startsWith('/admin')

  if (isAdminPage) {
    // 后台管理页面：始终使用登录认证的租户ID
    try {
      const adminUser = JSON.parse(localStorage.getItem('admin_user') || '{}')
      if (adminUser.tenantId) {
        return String(adminUser.tenantId)
      }
    } catch (e) {
      // ignore
    }
    return null
  }

  // 前台公开页面：URL参数优先
  // 1. 从URL查询参数获取（开发环境/分享链接/租户预览）
  const urlParams = new URLSearchParams(window.location.search)
  const urlTenantId = urlParams.get('tenant_id') || urlParams.get('tenantId') || urlParams.get('tenant')
  if (urlTenantId) {
    localStorage.setItem('tenant_id', urlTenantId)
    return urlTenantId
  }

  // 2. 从localStorage获取（之前通过URL参数保存的）
  const storedTenantId = localStorage.getItem('tenant_id')
  if (storedTenantId) {
    return storedTenantId
  }

  // 3. 没有明确的租户ID，返回null
  //    不发送 X-Tenant-Id header，让后端 TenantDomainInterceptor 从域名解析
  return null
}

// 请求拦截器 - 添加 Token 和租户ID
request.interceptors.request.use(
  config => {
    const token = localStorage.getItem('admin_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    // 添加租户ID（仅在有明确租户ID时发送，否则让后端从域名解析）
    const tenantId = resolveTenantId()
    if (tenantId) {
      config.headers['X-Tenant-Id'] = tenantId
    }
    return config
  },
  error => Promise.reject(error)
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    // 捕获后端返回的租户绑定域名
    const tenantDomain = response.headers['x-tenant-domain']
    if (tenantDomain) {
      currentTenantDomain = tenantDomain
    }
    const res = response.data
    if (res.code !== 200) {
      return Promise.reject(new Error(res.message || 'Error'))
    }
    return res
  },
  error => {
    console.error('API Error:', error)
    // 401 未授权 - 仅在后台管理页面跳转登录页
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('admin_token')
      localStorage.removeItem('admin_user')
      // 只有在后台管理页面才跳转到登录页，前台公开页面不跳转
      if (window.location.pathname.startsWith('/admin')) {
        if (window.location.pathname !== '/admin/login') {
          window.location.href = '/admin/login'
        }
      }
    }
    return Promise.reject(error)
  }
)

export default request
